export enum Variant {
  BACKGROUND = 'background',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  BORDER = 'background',
  TEXT = 'text',
  STROKE = 'stroke',
}
